var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 1,
    viewBox: "0 0 41 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h40",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeDasharray: "4 5"
  })));
}
SvgVector.displayName = 'Vector';
export default SvgVector;